import React from 'react';
export function ConnectionInsert() {
  return <section className="relative w-full overflow-hidden" data-id="element-62">
      {/* Full-width image */}
      <div className="relative w-full aspect-[4/3] md:aspect-[16/9]" data-id="element-63">
        <img src="https://cdn.magicpatterns.com/uploads/gdMLDsdtn11Ki66SS4YsfS/imagenlanding_2.png" alt="Correa suelta en sonrisa" className="w-full h-full object-cover" data-id="element-64" />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/50 to-charcoal/20" data-id="element-65"></div>

        {/* Text overlay */}
        <div className="absolute inset-0 flex items-end pb-10 md:pb-16 px-6" data-id="element-66">
          <div className="max-w-lg mx-auto w-full text-center" data-id="element-67">
            <p className="text-xl md:text-2xl text-white leading-relaxed font-medium italic" data-id="element-68">
              No es obediencia. Es una nueva forma de entenderos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}